<template>
  <card-item :infoKeys="infoKeys" card="item_client_cloud" :tabs="tabs" :activeTab="activeTab" :id="id"/>
</template>
<script>
export default {
  methods: {
  },
  props: ["id"],
  data() {
    return {
          infoKeys:[
        {
          key: 'id',
          title:'ID'
        },
        {
          key: 'full_name',
          title:'Ученик'
        },
        {
          key: 'phone',
          title:'Номер телефона'
        },
        ],
      tabs: [
        {
          title: "Информация", key:'information_card',
          component: () => import("./Info"),
        },
          {
               key:'guardians_card',
          title: "Родители",
          component: () => import("./ClientGuardian"),
        },
      ],
      activeTab: 0,
    };
  },
};
</script>